module.exports = __webpack_public_path__ + "static/media/featurewall.5af4070f.jfif";